import { render, staticRenderFns } from "./AdminEditProfile.vue?vue&type=template&id=cacd4c2a&"
import script from "./AdminEditProfile.vue?vue&type=script&lang=js&"
export * from "./AdminEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports